export default __webpack_public_path__ + "static/font-34806a202c6aecac547e33baae63e457.woff2";